// ─────────────────────────────────────────────────────────────────────────────
// PositionEditor.tsx — ContentSectionEditPageCareer
// ─────────────────────────────────────────────────────────────────────────────
import React, { useRef } from 'react';
import { PositionSection, PositionHeaderSection, PositionActionButton } from './types';
import { LabelRow, SplitRow, DraftTextField } from './components';

const PositionEditor: React.FC<{
  data:     PositionSection;
  onChange: (v: PositionSection) => void;
}> = ({ data, onChange }) => {
  // Frozen on mount — never mutated
  const orig = useRef(data);

  const header     = data.content[0]?.headerSection;
  const origHeader = orig.current.content[0]?.headerSection;

  const setHeader = (p: Partial<PositionHeaderSection>) =>
    onChange({
      ...data,
      content: [{
        ...data.content[0],
        headerSection: { ...header, ...p },
      }],
    });

  const setActionButton = (p: Partial<PositionActionButton>) =>
    setHeader({ actionButton: { ...header.actionButton, ...p } });

  if (!header || !origHeader) return null;

  return (
    <>
      <LabelRow
        label="Header section"
        toggle={{
          checked:  header.visible,
          onChange: v => setHeader({ visible: v }),
        }}
      />

      <LabelRow label="Main content title" required />
      <SplitRow currentText={`[ ${origHeader.label} ]`}>
        <DraftTextField
          placeholder="Main content title"
          onChange={v => setHeader({ label: v })}
        />
      </SplitRow>

      <LabelRow label="Tittle" required />
      <SplitRow currentText={origHeader.title}>
        <DraftTextField
          placeholder="Sector tittle"
          onChange={v => setHeader({ title: v })}
        />
      </SplitRow>

      <LabelRow
        label="Primary button"
        toggle={{
          checked:  header.actionButton.visible,
          onChange: v => setActionButton({ visible: v }),
        }}
      />
      <SplitRow currentText={origHeader.actionButton.label}>
        <DraftTextField
          placeholder="Text button"
          onChange={v => setActionButton({ label: v })}
        />
      </SplitRow>
    </>
  );
};

export default PositionEditor;